<template>
  <vx-card>
    <vs-table id="table" pagination search class="my-5" no-data-text="لا يوجد مواد دراسية" :data="courses" :total="courses.length">

      <div slot="header" class="flex flex-wrap lg:w-auto w-full">
        <input @change="importExcel" type="file" accept=".xlsx, .xls" class="hidden" ref="import" />
        <vs-dropdown vs-trigger-click class="cursor-pointer lg:w-auto w-full">
          <vs-button icon="icon-chevron-down" icon-pack="feather" icon-after class="lg:mt-0 mt-4 w-full">ملف xlsx</vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="$refs.import.click()">تحميل</vs-dropdown-item>
            <vs-dropdown-item @click="exportToExcel">إستخراج</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button v-if="hasRole('add_courses')" color="success" icon-pack="feather" icon="icon-plus" class="lg:mt-0 mt-4 lg:ml-3 w-full lg:w-auto" icon-after @click="openCourseForm">إضافة</vs-button>
      </div>

      <template slot="thead">
        <vs-th class="w-40" sort-key="id">رمز المادة</vs-th>
        <vs-th class="w-64" sort-key="name">إسم المادة</vs-th>
        <vs-th class="lg:block hidden" sort-key="description">الوصف</vs-th>
        <vs-th class="w-40">العمليات</vs-th>
      </template>

      <tbody slot-scope="{data}">
      <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
        <vs-td :data="tr.id">{{ tr.id }}</vs-td>
        <vs-td :data="tr.name">{{ tr.name }}</vs-td>
        <vs-td class="lg:block hidden" :data="tr.description">{{ tr.description }}</vs-td>
        <vs-td>
          <div class="flex">
            <vs-button v-if="hasRole('update_courses')" @click="openCourseForm(tr)" size="large" title="تعديل" color="primary" type="flat" class="ml-2" icon-pack="feather" icon="icon-edit"></vs-button>
            <vs-button v-if="hasRole('delete_courses')" @click="deleteCourse(tr)" size="large" title="حذف" color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
      </tbody>

    </vs-table>

    <course-form @submit="saveCourse" :data="courseData" :active.sync="isCourseFormActive"/>
  </vx-card>
</template>

<script>
    import coursesAPI from '@/api/admin/coursesAPI'
    import CourseForm from '@/views/admin/courses/CourseForm'
    import fileAPI from '@/api/fileAPI'

    export default {
        components: { CourseForm },
        data() {
            return {
                headerTitle: ['رمز المادة', 'إسم المادة', 'الوصف'],
                headerVal: ['id', 'name', 'description'],
                isCourseFormActive: false,
                courses: [],
                courseData: {},
                courseEditIndex: -1,
            }
        },
        methods: {
            exportToExcel() {
                import('@/vendor/Export2Excel').then(excel => {
                    const list = this.courses
                    const data = list.map(value => this.headerVal.map(key => value[key]))
                    excel.export_json_to_excel({
                        header: this.headerTitle,
                        data,
                        filename: 'المواد الدراسية',
                        desc: 'المواد الدراسية بالكلية'
                    })
                })
            },
            importExcel(event) {
                if(event.target.files){
                    const file = event.target.files[0]
                    if(!/\.(xlsx|xls|csv)$/.test(file.name)){
                        this.$notifyWarning('يجب ان يكون الملف من النوع Excel')
                        return;
                    }

                    const data = new FormData()
                    data.append('type', 'courses')
                    data.append('file', file)
                    fileAPI.import(data)
                }
            },
            openCourseForm(course){
                Object.assign(this.courseData = {}, course)
                this.courseEditIndex = this.courses.indexOf(course)
                this.isCourseFormActive = true
            },

            saveCourse(course){
                this.courseEditIndex !== -1 ? this.$set(this.courses, this.courseEditIndex, course) : this.courses.push(course)
            },

            deleteCourse(course){
                let message =  `هل انت متأكد بأنك تريد حذف المادة الدراسية ${course.name} (${course.id})`;
                this.$confirmAlert(null, message, () => {
                    coursesAPI.delete(course.id)
                        .then(response => {
                            this.courses.splice(this.courses.indexOf(course), 1)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(response => this.$notifyError(response.statusMessage))
                })
            },

            // deleteSelected(courses){
            //     let ids = courses.map(course => {return course.id})
            //
            //     coursesAPI.deleteMulti(ids)
            //         .then(response => {
            //             courses.forEach(course => this.courses.splice(this.courses.indexOf(course),1))
            //             this.$notifySuccess(response.successMessage)
            //         })
            //         .catch(error => this.$notifyError(error.statusMessage))
            // },
            loadData(){
                this.$startLoading('#table', 'white')
                coursesAPI.getAll()
                    .then(({data}) => this.courses = data)
                    .finally(() => this.$closeLoading('#table'))
            }
        },
        mounted() {
            this.loadData()
        },
    }

</script>
